import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { LOGO_URL } from "@/data/content";
import { ApplyButton } from "@/components/site/AdmissionBadge";
import { useSiteConfig } from "@/context/SiteConfigContext";
import { telHref } from "@/lib/links";

export function FinalCTA() {
  const { config } = useSiteConfig();
  return (
    <section className="relative overflow-hidden py-24 text-white" style={{ background: "radial-gradient(120% 100% at 50% 0%, #16347A, #0A1E4E 55%, #071538)" }} data-testid="final-cta-section">
      <div className="absolute inset-0 paper-grain opacity-40" />
      <div className="container-x relative text-center max-w-3xl">
        <motion.img
          src={LOGO_URL} alt="IAUE crest" className="mx-auto h-20 w-20 object-contain"
          initial={{ opacity: 0, scale: 0.8 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} transition={{ duration: 0.6 }}
        />
        <h2 className="mt-6 font-serif text-4xl sm:text-5xl font-bold">Your Next Step Starts Here.</h2>
        <p className="mt-5 text-lg text-blue-100/85 leading-relaxed">
          Whether you are exploring JUPEB, IJMB, or looking for another structured pathway toward university
          education, the School of Basic Studies is here to help you understand your options and take the next
          step with confidence.
        </p>
        <div className="mt-9 flex flex-wrap items-center justify-center gap-3">
          <ApplyButton className="btn-red" testId="final-apply-button">Apply Now</ApplyButton>
          <Link to="/jupeb" className="btn-outline-gold" data-testid="final-explore-jupeb">Explore JUPEB</Link>
          <Link to="/ijmb" className="btn-outline-gold" data-testid="final-explore-ijmb">Explore IJMB</Link>
          <Link to="/contact" className="btn-gold" data-testid="final-contact">Contact Us</Link>
        </div>
        <a href={telHref(config.phonePrimary)} className="mt-8 inline-flex items-center gap-2 text-lg font-bold hover:text-[#D4AF37]" data-testid="final-phone">
          <Phone size={18} className="text-[#D4AF37]" /> {config.phonePrimary}
        </a>
      </div>
    </section>
  );
}
